namespace spbm_ui {

   import IController = angular.IController;

   class DspViewController implements IController {
      public static $inject = ["i18nService", "$q"];
      public readonly detailsViewData: any;

      constructor(private i18nService: any,
                  private $q: ng.IQService) {
         this.detailsViewData = {
            tabsPromise: this.$q.when([
               {
                  name: this.i18nService.getString("SpbmUi", "h5.profile.details.rules"),
                  templateUrl: "spbm-ui/resources/spbm/views/profile/details/StorageProfileGeneralTab.html",
                  uid: "profile.generalTab"
               },
               {
                  name: this.i18nService.getString("SpbmUi", "dataservice.tabs.usedInTitle"),
                  templateUrl: "spbm-ui/resources/spbm/views/dsp/details/UsedInTab.html",
                  uid: "profile.usedInTab"
               }
            ])
         };
      }
   }

   angular.module("com.vmware.vsphere.client.spbm")
         .controller("DspViewController", DspViewController);
}
